import { Environment } from '@flexbenefits-ui/data-access-api';

export const environment: Environment = {
    production: true,
    apiUrl: 'https://flexbenefits.youforce.com/gateway',
    userInfoApiUrl: 'https://user.youforce.com/info',
    appName: 'FlexBenefits',
    version: '1.0.0',
    features: {
        enableDebugMode: false,
        enableMockData: false,
    },
    auth: {
        tokenKey: 'auth_token',
        refreshTokenKey: 'refresh_token',
    },
    youforceNavigationBar: {
        styleUrl:
            'https://static.youforceacc.com/mijn-youforce/navigation-bar/release/youforce-navigation-bar/youforce-navigation-bar.css',
        scriptUrl:
            'https://static.youforceacc.com/mijn-youforce/navigation-bar/release/youforce-navigation-bar/youforce-navigation-bar.esm.js',
    },
    loginUrl: 'https://login.youforce.com',
    homeUrl: 'https://flexbenefits.youforce.com/',
    appInsights: {
        instrumentationKey: '85bd6a09-78cc-408d-9486-71d27e8f9892',
    },
};
